'use client'

import FooterContent from '@/components/FooterContent'
import useApp from '@/lib/store'
import { cn } from '@/lib/utils'

export default function ContactModal({ settings }) {
	const {isContactOpen, setIsContactOpen} = useApp()

	return (
		<>

			<button aria-label='Close Contact' onClick={() => setIsContactOpen(false)} className={cn(`fixed z-700 top-0 mobile:top-[56px] right-0 mobile:right-auto mobile:left-0 px-site py-4 sm:py-12 transition-opacity duration-500 text-white dark:text-black`, {
				'opacity-100 pointer-events-auto' : isContactOpen,
				'opacity-0 pointer-events-none' : !isContactOpen
			})}>Close</button>

			<div className={cn(`contact-modal fixed inset-0 z-800 mobile:z-600 transition-opacity duration-500
			[&_~_.page-wrapper]:transition
			[&_~_.page-wrapper]:duration-500
			[&_~_.page-wrapper]:translate-y-0
			[&.contact-is-open_~_.home-intro-logo]:-translate-y-[30dvh]xxx
			[&.contact-is-open_~_.home-intro-logo]:opacity-0
			[&.contact-is-open_~_.home-intro-logo]:pointer-events-none
			[&.contact-is-open_~_.page-wrapper]:-translate-y-[30dvh]
			[&.contact-is-open_~_.page-wrapper]:opacity-0
			[&.contact-is-open_~_.page-wrapper]:pointer-events-none`, {
				'opacity-100 pointer-events-auto contact-is-open' : isContactOpen,
				'opacity-0 pointer-events-none' : !isContactOpen
			})}>

				<FooterContent settings={settings} />

			</div>

		</>
	)
}
